import { render, staticRenderFns } from "./OsExternaComponent.vue?vue&type=template&id=3f895b8e&"
import script from "./OsExternaComponent.vue?vue&type=script&lang=js&"
export * from "./OsExternaComponent.vue?vue&type=script&lang=js&"
import style0 from "./OsExternaComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports